import * as vp from 'vopay';

type AddSignerRows = {
  label: vp.AddSignerLabel;
  id: vp.AddSignerId;
  preset: keyof vp.TextFieldPresets | undefined;
};

const buildEditSignerRows = (): AddSignerRows[] => [
  {
    label: vp.AddSignerLabel.AuthorizedFullLegalName,
    id: vp.AddSignerId.AuthorizedFullLegalName,
    preset: 'text',
  },
  {
    label: vp.AddSignerLabel.AuthorizedEmailAddress,
    id: vp.AddSignerId.AuthorizedEmailAddress,
    preset: 'text',
  },
  {
    label: vp.AddSignerLabel.AuthorizedOccupation,
    id: vp.AddSignerId.AuthorizedOccupation,
    preset: 'text',
  },
];

export default buildEditSignerRows;
